// GA4 loader — consent-gated, env-gated.
// No GA4_ID set => banner hidden, nothing loads. ID set => loads only after the visitor accepts.
const GA4_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let loaded = false;

export function ga4Configured() {
  return Boolean(GA4_ID);
}

export function initGa4() {
  if (!GA4_ID || loaded || typeof document === "undefined") return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(s);
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID, { anonymize_ip: true, send_page_view: false });
}

export function trackPageView(path) {
  if (GA4_ID && typeof window.gtag === "function") {
    window.gtag("event", "page_view", { page_path: path, page_location: window.location.href });
  }
}
